module.exports = __webpack_public_path__ + "img/fig09.23848187.jpg";